import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { handleDeactivateDialogClose } from '../../../../../common/properties/formFunctions';

class DeactivateDialog extends React.Component {
  deactivateProperty = (e) => {
    const { component, propertyId, updatePropertyWithImages } = this.props;
    e.preventDefault();
    const updatedProperty = { id: propertyId, active: false };
    handleDeactivateDialogClose(component);
    updatePropertyWithImages(updatedProperty, []);
  }

  render() {
    const { component, confirmDeactivate } = this.props;

    const deactivatePropertyActions = [
      <FlatButton
        label="Hætta við" labelStyle={{ color: '#222222' }}
        onTouchTap={() => handleDeactivateDialogClose(component)}
      />,
      <FlatButton
        label="Óvirkja" labelStyle={{ color: '#FBAD36' }}
        onTouchTap={this.deactivateProperty}
      />,
    ];

    return (
      <Dialog
        title="Óvirkja auglýsingu" actions={deactivatePropertyActions}
        modal={false} open={confirmDeactivate}
        onRequestClose={() => handleDeactivateDialogClose(component)}
      >
        Ertu viss um að þú viljir óvirkja þessa eign? <br /> <br />
        Eignin mun lifa áfram en enginn annar en þú getur fundið hana. <br />
        Þú getur fundið hana undir &#39;Mínar eignir&#39;, en þar geturðu skoðað hana,
        breytt, eytt eða virkt hana aftur.
      </Dialog>
    );
  }
}

DeactivateDialog.propTypes = {
  component: React.PropTypes.any.isRequired,
  propertyId: React.PropTypes.string.isRequired,
  confirmDeactivate: React.PropTypes.bool.isRequired,
  updatePropertyWithImages: React.PropTypes.func.isRequired,
};

export default DeactivateDialog;



// WEBPACK FOOTER //
// ./src/browser/app/components/Dialogs/DeactivateDialog/DeactivateDialog.js